export default {
  ORDER_REMINDER: {
    ENQUEUE: "ORDER_REMINDER.ENQUEUE",
    DEQUEUE: "ORDER_REMINDER.DEQUEUE",
  },
};
